import apiClient from "./apiClient";
import {
  CONTROL_EFFECTIVENESS_CATEGORY,
  DEFAULT_CONTROL_EFFECTIVENESS_CONFIG,
  mergeControlEffectivenessConfig,
} from "../utils/controlEffectiveness";

let configCache = null;
let configInflight = null;

const clonePayload = (payload) => ({
  category: CONTROL_EFFECTIVENESS_CATEGORY,
  items: mergeControlEffectivenessConfig(payload?.items || DEFAULT_CONTROL_EFFECTIVENESS_CONFIG).map((item) => ({ ...item })),
});

export const clearControlEffectivenessConfigCache = () => {
  configCache = null;
  configInflight = null;
};

export const getControlEffectivenessConfig = async ({ force = false } = {}) => {
  if (configCache && !force) {
    return { data: clonePayload(configCache) };
  }
  if (configInflight && !force) {
    return configInflight;
  }

  configInflight = apiClient
    .get("/control-effectiveness-config")
    .then((response) => {
      configCache = clonePayload(response?.data || {});
      return { ...response, data: clonePayload(configCache) };
    })
    .catch((error) => {
      configCache = clonePayload({});
      throw error;
    })
    .finally(() => {
      configInflight = null;
    });

  return configInflight;
};

export const updateControlEffectivenessConfig = async (payload) => {
  const response = await apiClient.put("/control-effectiveness-config", {
    items: mergeControlEffectivenessConfig(payload?.items || []).map((item) => ({
      value: item.value,
      label: item.label,
      color: item.color,
      position: item.position,
      status: item.status || "active",
    })),
  });
  configCache = clonePayload(response?.data || payload || {});
  return { ...response, data: clonePayload(configCache) };
};
